// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Toggle } from '@carbon/react';
import { useShellStore } from '../../stores/shellStore';
import { PageHead } from '../../components/shell/ScreenHelpers';

/** Preferences — appearance (theme) + accessibility, persisted in shellStore. */
export default function Preferences() {
  const theme = useShellStore(s => s.theme);
  const setTheme = useShellStore(s => s.setTheme);
  const a11y = useShellStore(s => s.a11y);
  const setA11y = useShellStore(s => s.setA11y);

  return (
    <div className="hs-page">
      <PageHead title="Preferences" dateline="Appearance & accessibility · saved on this device" />

      <div style={{ display: 'grid', gap: 20, maxWidth: 560 }}>
        <section>
          <div className="helios-subnav-title" style={{ padding: '0 0 8px' }}>
            Appearance
          </div>
          <div className="hs-toolbar">
            <button
              type="button"
              className={`hs-pill${theme === 'g100' ? ' active' : ''}`}
              onClick={() => setTheme('g100')}
            >
              Dark
            </button>
            <button
              type="button"
              className={`hs-pill${theme === 'g10' ? ' active' : ''}`}
              onClick={() => setTheme('g10')}
            >
              Light
            </button>
          </div>
        </section>

        <section>
          <div className="helios-subnav-title" style={{ padding: '0 0 8px' }}>
            Accessibility
          </div>
          <div style={{ display: 'grid', gap: 16 }}>
            <Toggle
              id="pref-reduce-motion"
              labelText="Reduce motion"
              labelA="Off"
              labelB="On"
              toggled={a11y.reduceMotion}
              onToggle={v => setA11y({ reduceMotion: v })}
            />
            <Toggle
              id="pref-large-text"
              labelText="Large text"
              labelA="Off"
              labelB="On"
              toggled={a11y.largeText}
              onToggle={v => setA11y({ largeText: v })}
            />
            <Toggle
              id="pref-high-contrast"
              labelText="High contrast"
              labelA="Off"
              labelB="On"
              toggled={a11y.highContrast}
              onToggle={v => setA11y({ highContrast: v })}
            />
            <Toggle
              id="pref-sound"
              labelText="Alarm sound"
              labelA="Off"
              labelB="On"
              toggled={a11y.soundAlerts}
              onToggle={v => setA11y({ soundAlerts: v })}
            />
          </div>
        </section>
      </div>
    </div>
  );
}
